/* unplugin-vue-components disabled */export default defineComponent({
  name: 'CColumn',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
});